import DeviceTypeAttributes from "./deviceType/PluginSetup.js";
import DeviceGroupAttributes from "./deviceGroup/PluginSetup.js";
import FirmwareReleaseAttributes from "./firmwareRelease/PluginSetup.js";
import Renderers from "./renderers/PluginSetup.js";
import FirmwareApplicationAttributes from "./firmwareApplication/PluginSetup.js";
import FirmwareComponentAttributes from "./firmwareComponent/PluginSetup.js";
import DeviceAttributes from "./device/PluginSetup.js";
function install(molten) {
  DeviceTypeAttributes.install(molten);
  DeviceGroupAttributes.install(molten);
  FirmwareReleaseAttributes.install(molten);
  Renderers.install(molten);
  FirmwareApplicationAttributes.install(molten);
  FirmwareComponentAttributes.install(molten);
  DeviceAttributes.install(molten);
}
export { install };
export default {
  install
};